// extracted by mini-css-extract-plugin
export default {"card":"_1-z","carouselContainer":"a2-z","carouselContent":"b2-z"};